import { useState, useEffect } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { Helmet } from 'react-helmet';
import api from '../../services/api';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import axios from 'axios';


const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [blogsPerPage] = useState(10); // Number of blogs per page
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 2000,
    totalPages: 1
  });

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        setError(null);
        
               const response = await axios.get(
          'https://www.startupbusinesspartners.com/api/blog',
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }
        );
        
        if (!response.data.success) {
          throw new Error('Failed to fetch blogs');
        }

        // Set the blogs data from the response
        setBlogs(response.data.data);
        // Set pagination data if available
        if (response.data.pagination) {
          setPagination(response.data.pagination);
        }
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError(err.message || 'Failed to load blogs');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [currentPage]); // Add currentPage to dependencies if implementing server-side pagination

  // Get current blogs
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return { day, month, year };
  };
const truncateExcerpt = (text, wordCount) => {
  const words = text.split(' ');
  if (words.length > wordCount) {
    return words.slice(0, wordCount).join(' ') + '...';
  }
  return text;
};
  if (loading) {
    return (
      <div className="home-page">
        <Helmet>
          <title>Blog - startupbusinesspartners</title>
        </Helmet>
        <Navbar />
        <div className="text-center py-5">Loading blogs...</div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="home-page">
        <Helmet>
          <title>Blog - startupbusinesspartners</title>
        </Helmet>
        <Navbar />
        <div className="text-center py-5">Error: {error}</div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="home-page">
      <Helmet>
        <title>Blog - startupbusinesspartners</title>
      </Helmet>
      
      <Navbar />
      
      <section className="breadcrumb_area breadcrumb2 bgimage biz_overlay">
        <div className="bg_image_holder" style={{backgroundImage: 'url("img/breadbg.jpg")', opacity: 1}}>
          <img src="img/breadbg.jpg" alt="img/breadbg.jpg" />
        </div>
        <div className="container content_above">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                <h4 className="page_title">Blog</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb m-bottom-30">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Blog</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding section-bg">
        <div className="container">
          <div className="row">
            {currentBlogs.length > 0 ? (
              currentBlogs.map((blog) => {
                const { day, month, year } = formatDate(blog.created_at);
                
                return (
                  <div className="col-lg-12 mb-4" key={blog.id}>
                    <div className="event-single d-flex flex-wrap" style={{marginBottom:'130px!important'}}>
                      <div className="event-date">
                        <h1 className="display-1">{day}</h1>
                        <span className="month">{month}</span>
                        <span className="year">{year}</span>
                      </div>
                      <div className="event-info" style={{background:'#fff'}}>
                        <div>
                          <h5><a href={`/blog/${blog.slug}`}>{blog.title}</a></h5>
                        <p className="mb-3">{truncateExcerpt(blog.excerpt, 30)}</p>
                          <ul className="icon-list--two">
                            <li className="list-item icon-list">
                              <span className="color-primary"><i className="la la-user"></i></span> By {blog.author}
                            </li>
                            {blog.tags && (
                              <li className="list-item icon-list">
                                <span className="color-primary"><i className="la la-tags"></i></span> 
                                {blog.tags.split(',').join(', ')}
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="view-btn">
                     
                          <Link to={`/blog/${blog.slug}`}  className="btn btn-outline-primary btn-icon icon-right"
                          >
                            Read More <span className="la la-arrow-right"></span></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12 text-center py-5">
                <p>No blogs found.</p>
              </div>
            )}
          </div>

          {/* Pagination */}
          {blogs.length > blogsPerPage && (
            <div className="row">
              <div className="col-12">
                <nav aria-label="Blog pagination">
                  <ul className="pagination justify-content-center">
                    {Array.from({ length: Math.ceil(blogs.length / blogsPerPage) }).map((_, index) => (
                      <li 
                        key={index} 
                        className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                      >
                        <button 
                          onClick={() => paginate(index + 1)} 
                          className="page-link"
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Blog;